var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.state.lang,staticClass:"app",class:{
    english: _vm.state.lang == 'en',
    persian: _vm.state.lang == 'fa',
    home: _vm.$route.name === 'home',
  },attrs:{"dir":_vm.$isRTL() ? 'rtl' : 'ltr'}},[(!_vm.$route.path.includes('Panel'))?_c('PublicNavbar'):_vm._e(),(_vm.state.loading)?_c('LoadingPage'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }